import {
  AccountCircleOutlined,
  PaymentsOutlined,
  VerifiedOutlined,
  WalletOutlined,
} from "@mui/icons-material";

// API endpoints
export const ENDPOINT = process.env.REACT_APP_API_ENDPOINT;
export const SIGN_IN = `${ENDPOINT}/users/sign-in`;
export const SIGN_UP = `${ENDPOINT}/users/sign-up`;
export const CREATE_ORDER = `${ENDPOINT}/users/create-order`;
export const GET_MY_PROFILE = `${ENDPOINT}/users/me`;

// Cookie
export const REFRESH_TOKEN_KEY = "x-refresh-token";
export const ACCESS_TOKEN_KEY = "x-access-token";
export const profileSidebarMenuList = [
  {
    href: "/profile",
    label: "My Profile",
    icon: AccountCircleOutlined,
  },
  {
    href: "/profile/verification",
    label: "Verification",
    icon: VerifiedOutlined,
  },
  {
    href: "/profile/payments",
    label: "Payment",
    icon: PaymentsOutlined,
  },
  {
    href: "/profile/mywallet",
    label: "My Wallet",
    icon: WalletOutlined,
  },
];

export const imageFileTypes = [
  "image/png",
  "image/jpeg",
  "image/jpg",
  "image/gif",
  "image/webp",
];
export const fileExtensions = imageFileTypes.map((type) => type.split("/")[1]);
export const allExtensionsString = `${fileExtensions
  .join(", ")
  .replace(/,([^,]*)$/, ", or$1")}`;
